import React, { Component } from "react";
import PropTypes from "prop-types";
import reactCSS from "reactcss";
import ReactSVG from "react-svg";

class Icon extends Component {
  static defaultProps = {
    noPadding: false,
    width: "30px",
    height: "30px",
    style: {},
    iconStyle: {}
  };

  static propTypes = {
    src: PropTypes.any,
    noPadding: PropTypes.bool,
    style: PropTypes.object,
    iconStyle: PropTypes.object
  };

  render() {
    const styles = reactCSS({
      default: {
        element: {
          padding: !!this.props.noPadding ? "0px" : "12px"
        },
        icon: {
          width: this.props.width,
          height: this.props.height
        }
      }
    });

    return (
      <div
        className="icon"
        style={Object.assign({}, styles.element, this.props.style)}
      >
        {this.props.src && (
          <ReactSVG
            path={this.props.src}
            className="svg"
            style={Object.assign({}, styles.icon, this.props.iconStyle)}
          />
        )}
      </div>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/support/icon/index.jsx